import type { ProposalAlternate } from "@/lib/opportunity/proposalAlternateTypes";
import { isPrimaryProposalPackageKey } from "@/lib/opportunity/proposalPrimaryPackage";

type Props = {
  alternates: ProposalAlternate[];
  onEdit: (alt: ProposalAlternate) => void;
  onDelete: (alternateKey: string) => void;
};

export function ProposalPackageList(props: Props) {
  const { alternates, onEdit, onDelete } = props;
  return (
    <ul className="space-y-2">
      {alternates.map((alt) => {
        const primary = isPrimaryProposalPackageKey(alt.alternate_key);
        return (
          <li
            key={alt.id}
            className={
              "flex flex-wrap items-center justify-between gap-2 rounded-lg border px-3 py-2 text-sm " +
              (primary
                ? "border-indigo-300 bg-indigo-50/60 dark:border-indigo-800 dark:bg-indigo-950/30"
                : "border-gray-200 bg-white dark:border-zinc-700 dark:bg-zinc-900")
            }
          >
            <div>
              <span className="font-medium text-gray-900 dark:text-zinc-100">{alt.label}</span>
              <span className="ml-2 font-mono text-xs text-gray-500">{alt.alternate_key}</span>
              {primary ? (
                <span className="ml-2 text-[10px] font-semibold uppercase tracking-wide text-indigo-600 dark:text-indigo-300">
                  required
                </span>
              ) : null}
            </div>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => onEdit(alt)}
                className="rounded border border-gray-300 px-2 py-1 text-xs dark:border-zinc-600"
              >
                Edit
              </button>
              {!primary ? (
                <button
                  type="button"
                  onClick={() => onDelete(alt.alternate_key)}
                  className="rounded border border-red-300 px-2 py-1 text-xs text-red-700 dark:border-red-800 dark:text-red-300"
                >
                  Delete
                </button>
              ) : null}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
